<template>
    <!--  <Modal-->
    <!--      v-model="_value"-->
    <!--      width="400"-->
    <!--      :closable="false"-->
    <!--      @on-visible-change="visibleChange"-->
    <!--      >-->
    <Drawer :title="installed" placement="left" v-model="_value" width="70">
        <div style="font-size: 20px;">
            <Tree :data="treeData" expand-node :render="renderContent"></Tree>

            <set-reporting-interval-modal v-model="setReportingIntervalModal" :initValue="setReportingIntervalId"></set-reporting-interval-modal>
            <set-fatigue-driving-alarm-difference-modal v-model="setFatigueDrivingAlarmDifferenceModal" :initValue="setFatigueDrivingAlarmDifferenceId"></set-fatigue-driving-alarm-difference-modal>
            <set-over-speed-alarm-difference-modal v-model="setOverSpeedAlarmDifferenceModal" :initValue="setOverSpeedAlarmDifferenceId"></set-over-speed-alarm-difference-modal>
            <set-max-stop-time-modal v-model="setMaxStopTimeModal" :initValue="setMaxStopTimeId"></set-max-stop-time-modal>
            <set-min-resting-time-modal v-model="setMinRestingTimeModal" :initValue="setMinRestingTimeId"></set-min-resting-time-modal>
            <set-continue-drive-limit-per-day-modal v-model="setContinueDriveLimitPerDayModal" :initValue="setContinueDriveLimitPerDayId"></set-continue-drive-limit-per-day-modal>
            <set-continue-drive-limit-modal v-model="setContinueDriveLimitModal" :initValue="setContinueDriveLimitId"></set-continue-drive-limit-modal>
            <set-over-speed-duration-modal v-model="setOverSpeedDurationModal" :initValue="setOverSpeedDurationId"></set-over-speed-duration-modal>
            <set-max-speed-modal v-model="setMaxSpeedModal" :initValue="setMaxSpeedId"></set-max-speed-modal>

        </div>
    </Drawer>
</template>
<script>
    import SetReportingIntervalModal from '@/views/ddm/components/set-reporting-interval-modal'
    import SetFatigueDrivingAlarmDifferenceModal from '@/views/ddm/components/set-fatigue-driving-alarm-difference-modal'
    import SetOverSpeedAlarmDifferenceModal from '@/views/ddm/components/set-over-speed-alarm-difference-modal'
    import SetMaxStopTimeModal from '@/views/ddm/components/set-max-stop-time-modal'
    import setMinRestingTimeModal from '@/views/ddm/components/set-min-resting-time-modal'
    import SetContinueDriveLimitPerDayModal from '@/views/ddm/components/set-continue-drive-limit-per-day-modal'
    import SetContinueDriveLimitModal from '@/views/ddm/components/set-continue-drive-limit-modal'
    import SetOverSpeedDurationModal from '@/views/ddm/components/set-over-speed-duration-modal'
    import SetMaxSpeedModal from '@/views/ddm/components/set-max-speed-modal'

    import Vue from 'vue';
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

    export default {
        name: 'selectsendterminalparametersmodal',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null,
            installed: null
        },
        components: {
            SetReportingIntervalModal,
            SetFatigueDrivingAlarmDifferenceModal,
            SetOverSpeedAlarmDifferenceModal,
            SetMaxStopTimeModal,
            setMinRestingTimeModal,
            SetContinueDriveLimitPerDayModal,
            SetContinueDriveLimitModal,
            SetOverSpeedDurationModal,
            SetMaxSpeedModal,
        },
        data() {
            return {
                //设置汇报间隔
                setReportingIntervalModal: false,
                setReportingIntervalId: null,

                // 设置疲劳驾驶预警差值
                setFatigueDrivingAlarmDifferenceModal: false,
                setFatigueDrivingAlarmDifferenceId: null,

                // 设置超速报警预警差值
                setOverSpeedAlarmDifferenceModal: false,
                setOverSpeedAlarmDifferenceId: null,

                // 设置最长停车时间
                setMaxStopTimeModal: false,
                setMaxStopTimeId: null,

                // 设置最小休息时间
                setMinRestingTimeModal: false,
                setMinRestingTimeId: null,

                // 设置当天累计驾驶时间门限
                setContinueDriveLimitPerDayModal:false,
                setContinueDriveLimitPerDayId:null,

                // 设置连续驾驶时间门限
                setContinueDriveLimitModal:false,
                setContinueDriveLimitId:null,

                //设置超速持续时间
                setOverSpeedDurationModal:false,
                setOverSpeedDurationId:null,

                //设置最高速度
                setMaxSpeedModal:false,
                setMaxSpeedId:null,

                vehicleInfo: {
                    identificationCode: null
                },
                installOrder: {},

                treeData: [
                    {
                        title: '设置终端参数',
                        expand: true,
                        children: [
                            {
                                title: '汇报间隔',
                            },
                            {
                                title: '疲劳驾驶预警差值',
                            },
                            {
                                title: '超速报警预警差值',
                            },
                            {
                                title: '最长停车时间',
                            },
                            {
                                title: '最小休息时间',
                            },
                            {
                                title: '当天累计驾驶时间门限',
                            },
                            {
                                title: '连续驾驶时间门限',
                            },
                            {
                                title: '超速持续时间',
                            },
                            {
                                title: '最高速度',
                            },
                        ]
                    },
                ]

            }
        },
        methods: {
            ...mapActions([]),
            visibleChange(val) {
                if (val) {
                    this._initValue
                }
            },
            renderContent(h, { root, node, data }){
                return h('span',{
                    style:{
                        color:'#666',
                        cursor:'pointer',
                        fontSize:'15px'
                    },
                    domProps:{
                        className:'btn'
                    },
                    on:{
                        click:(e)=>{
                            //用nodeKey调用方法
                            console.log(data.nodeKey)
                            console.log(this._initValue)//jt808,id

                            if (data .nodeKey == 1) {
                                this.setReportingIntervalModal = true
                                this.setReportingIntervalId = this._initValue
                            }
                            if (data .nodeKey == 2) {
                                this.setFatigueDrivingAlarmDifferenceModal = true
                                this.setFatigueDrivingAlarmDifferenceId = this._installed
                            }
                            if (data .nodeKey == 3) {
                                this.setOverSpeedAlarmDifferenceModal = true
                                this.setOverSpeedAlarmDifferenceId = this._installed
                            }
                            if (data .nodeKey == 4) {
                                this.setMaxStopTimeModal = true
                                this.setMaxStopTimeId = this._installed
                            }
                            if (data .nodeKey == 5) {
                                this.setMinRestingTimeModal = true
                                this.setMinRestingTimeId = this._installed
                            }
                            if (data .nodeKey == 6) {
                                this.setContinueDriveLimitPerDayModal = true
                                this.setContinueDriveLimitPerDayId = this._installed
                            }
                            if (data .nodeKey == 7) {
                                this.setContinueDriveLimitModal = true
                                this.setContinueDriveLimitId = this._installed
                            }
                            if (data .nodeKey == 8) {
                                this.setOverSpeedDurationModal = true
                                this.setOverSpeedDurationId = this._installed
                            }
                            if (data .nodeKey == 9) {
                                this.setMaxSpeedModal = true
                                this.setMaxSpeedId = this._installed
                            }
                        }
                    }
                },data.title)
            }

        },
        computed: {
            _value: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _installed: {
                get() {
                    return this.installed
                },
                set(val) {
                    // this.$emit('input', val)
                    // this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            },
        },
        mounted() {
            this.$nextTick(() => {

            })
        }
    }
</script>
<style>
    .demo-split {
        height: 500px;
        border: 1px solid #dcdee2;
    }

    .demo-split-pane {
        padding: 10px;
    }
</style>
